import { render, staticRenderFns } from "./versionAchievement.vue?vue&type=template&id=e48a719e&scoped=true&"
import script from "./versionAchievement.vue?vue&type=script&lang=js&"
export * from "./versionAchievement.vue?vue&type=script&lang=js&"
import style0 from "./versionAchievement.vue?vue&type=style&index=0&id=e48a719e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e48a719e",
  null
  
)

export default component.exports